import React, { useState } from 'react';

import { Help } from '@mui/icons-material';
import { Button } from '@mui/material';

import HelpModal from './HelpModal';

/**
 * Button to display modal dialog explaining whiteboard hotkeys and their functions.
 */
const HelpButton = React.memo(() => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);

    return (
        <>
            <Button
                style={{ minWidth: 0, padding: '0.45rem', margin: '1.5px' }}
                variant="contained"
                color="inherit"
                disableElevation
                onClick={() => setDialogOpen(!dialogOpen)}
            >
                <Help sx={{ fill: '#666' }}/>
            </Button>
            <HelpModal open={dialogOpen} onClose={() => setDialogOpen(!dialogOpen)}/>
        </>
    );
});

export default HelpButton;
